"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JetReserveAsset = void 0;
const big_js_1 = __importDefault(require("big.js"));
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const anchor = __importStar(require("@project-serum/anchor"));
const jet_engine_1 = require("@jet-lab/jet-engine");
const asset_1 = require("./asset");
const utils_1 = require("../utils");
const utils_2 = require("./utils");
class JetReserveAsset extends asset_1.LendingMarket {
    constructor(provider, accounts, market, reserve, reserveToken, lpToken) {
        super();
        this.provider = provider;
        this.accounts = accounts;
        this.market = market;
        this.reserve = reserve;
        this.reserveToken = reserveToken;
        this.lpToken = lpToken;
    }
    static load(provider, cluster, reserveMint) {
        return __awaiter(this, void 0, void 0, function* () {
            let client;
            let market;
            if (cluster == "devnet") {
                client = yield jet_engine_1.JetClient.connect(provider, true);
                market = yield jet_engine_1.JetMarket.load(client, jet_engine_1.JET_MARKET_ADDRESS_DEVNET);
            }
            else if (cluster == "mainnet-beta") {
                client = yield jet_engine_1.JetClient.connect(provider, false);
                market = yield jet_engine_1.JetMarket.load(client, jet_engine_1.JET_MARKET_ADDRESS);
            }
            else {
                throw new Error("Cluster ${cluster} not supported");
            }
            const reserves = yield jet_engine_1.JetReserve.loadMultiple(client, market);
            const reserve = reserves.find((res) => res.data.tokenMint.equals(reserveMint));
            const accounts = {
                program: jet_engine_1.JET_ID,
                reserve: reserve.data.address,
                market: market.address,
                marketAuthority: market.marketAuthority,
                feeNoteVault: reserve.data.feeNoteVault,
                depositNoteMint: reserve.data.depositNoteMint,
                liquiditySupply: reserve.data.vault,
                pythPrice: reserve.data.pythOraclePrice,
            };
            const lpToken = yield (0, utils_2.getToken)(provider.connection, reserve.data.depositNoteMint);
            const reserveToken = yield (0, utils_2.getToken)(provider.connection, reserve.data.tokenMint);
            return new JetReserveAsset(provider, accounts, market, reserve, reserveToken, lpToken);
        });
    }
    /**
     * Creates a market, reserves, and adds initial liquidity
     *
     * TODO Split into create market adding reserves to it
     *
     * @param provider
     * @param owner
     * @param marketQuoteTokenMint
     * @param reserveSplToken
     * @param pythPrice
     * @param pythProduct
     * @param ownerReserveTokenAccount
     * @param initialReserveAmount
     * @returns
     */
    static initialize(provider, wallet, owner, marketQuoteTokenMint, reserveSplToken, pythPrice, pythProduct, ownerReserveTokenAccount, initialReserveAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const client = yield jet_engine_1.JetClient.connect(provider, true);
            const market = yield createLendingMarket(client, wallet, marketQuoteTokenMint);
            const accounts = yield createReserve(wallet, client, market.address, marketQuoteTokenMint, reserveSplToken, spl_token_1.TOKEN_PROGRAM_ID, // dummy dex market addr
            pythPrice, pythProduct);
            const reserve = yield jet_engine_1.JetReserve.load(client, accounts.reserve);
            const jetUser = yield jet_engine_1.JetUser.load(client, market, [reserve], owner.publicKey);
            const depositTx = yield jetUser.makeDepositTx(reserve, ownerReserveTokenAccount, jet_engine_1.Amount.tokens(initialReserveAmount));
            yield provider.send(depositTx, [owner]);
            const lpToken = yield (0, utils_2.getToken)(provider.connection, reserve.data.depositNoteMint);
            const reserveToken = yield (0, utils_2.getToken)(provider.connection, reserve.data.tokenMint);
            return new JetReserveAsset(provider, accounts, market, reserve, reserveToken, lpToken);
        });
    }
    borrow(owner, reserveTokenAccount, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const jetUser = yield jet_engine_1.JetUser.load(yield jet_engine_1.JetClient.connect(this.provider, true), this.market, [this.reserve], owner.publicKey);
            const depositCollateralTx = yield jetUser.makeDepositCollateralTx(this.reserve, jet_engine_1.Amount.tokens(amount * 1.5));
            const borrowTx = yield jetUser.makeBorrowTx(this.reserve, reserveTokenAccount, jet_engine_1.Amount.tokens(amount));
            return yield this.provider.sendAll([
                { tx: depositCollateralTx, signers: [owner] },
                { tx: borrowTx, signers: [owner] },
            ]);
        });
    }
    getLpTokenAccountValue(address) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.market.refresh();
            const reserveInfo = this.market.reserves[this.reserve.data.index];
            const exchangeRate = new big_js_1.default(reserveInfo.depositNoteExchangeRate.toString()).div(new big_js_1.default(1e15));
            const lpToken = new spl_token_1.Token(this.provider.connection, this.reserve.data.depositNoteMint, spl_token_1.TOKEN_PROGRAM_ID, web3_js_1.Keypair.generate() // dummy signer since we aren't making any txs
            );
            const lpTokenAccountInfo = yield lpToken.getAccountInfo(address);
            const lpTokenAmount = new big_js_1.default(lpTokenAccountInfo.amount.toString());
            return utils_1.TokenAmount.fromToken(this.reserveToken, exchangeRate.mul(lpTokenAmount).round(0, big_js_1.default.roundDown));
        });
    }
    getApy() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reserve.refresh();
            const apr = this.reserve.data.depositApy;
            const apy = Math.expm1(apr);
            return new utils_1.Rate((0, big_js_1.default)(apy));
        });
    }
    getDepositedAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reserve.refresh();
            return utils_1.TokenAmount.fromToken(this.reserveToken, (0, big_js_1.default)(this.reserve.data.marketSize.lamports.toString()));
        });
    }
    getBorrowedAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reserve.refresh();
            const borrowed = this.reserve.data.marketSize.sub(this.reserve.data.availableLiquidity);
            return utils_1.TokenAmount.fromToken(this.reserveToken, (0, big_js_1.default)(borrowed.lamports.toString()));
        });
    }
}
exports.JetReserveAsset = JetReserveAsset;
function createLendingMarket(client, wallet, quoteCurrencyMint) {
    return __awaiter(this, void 0, void 0, function* () {
        const account = web3_js_1.Keypair.generate();
        yield client.program.rpc.initMarket(wallet.publicKey, "USD", quoteCurrencyMint, {
            accounts: {
                market: account.publicKey,
            },
            signers: [account],
            instructions: [
                yield client.program.account.market.createInstruction(account),
            ],
        });
        return jet_engine_1.JetMarket.load(client, account.publicKey);
    });
}
function createReserve(wallet, client, market, quoteTokenMint, tokenMint, dexMarket, pythPrice, pythProduct) {
    return __awaiter(this, void 0, void 0, function* () {
        const reserve = web3_js_1.Keypair.generate();
        const [depositNoteMint, depositNoteMintBump] = yield findProgramAddress(client.program.programId, ["deposits", reserve, tokenMint]);
        const [loanNoteMint, loanNoteMintBump] = yield findProgramAddress(client.program.programId, ["loans", reserve, tokenMint]);
        const [vault, vaultBump] = yield findProgramAddress(client.program.programId, ["vault", reserve]);
        const [feeNoteVault, feeNoteVaultBump] = yield findProgramAddress(client.program.programId, ["fee-vault", reserve]);
        const [dexSwapTokens, dexSwapTokensBump] = yield findProgramAddress(client.program.programId, ["dex-swap-tokens", reserve]);
        const [dexOpenOrders, dexOpenOrdersBump] = yield findProgramAddress(client.program.programId, ["dex-open-orders", reserve]);
        const [marketAuthority] = yield findProgramAddress(client.program.programId, [market]);
        const reserveAccounts = {
            accounts: {
                reserve,
                vault,
                feeNoteVault,
                dexOpenOrders,
                dexSwapTokens,
                tokenMint,
                dexMarket,
                pythPrice,
                pythProduct,
                depositNoteMint,
                loanNoteMint,
            },
            bump: {
                vault: vaultBump,
                feeNoteVault: feeNoteVaultBump,
                dexOpenOrders: dexOpenOrdersBump,
                dexSwapTokens: dexSwapTokensBump,
                depositNoteMint: depositNoteMintBump,
                loanNoteMint: loanNoteMintBump,
            },
        };
        const reserveConfig = {
            utilizationRate1: 8500,
            utilizationRate2: 9500,
            borrowRate0: 50,
            borrowRate1: 600,
            borrowRate2: 4000,
            borrowRate3: 1600,
            minCollateralRatio: 12500,
            liquidationPremium: 300,
            manageFeeRate: 0,
            manageFeeCollectionThreshold: new anchor.BN(10),
            loanOriginationFee: 0,
            liquidationSlippage: 300,
            liquidationDexTradeMax: new anchor.BN(100),
            reserved0: 0,
            reserved1: Array(24).fill(0),
        };
        yield client.program.rpc.initReserve(reserveAccounts.bump, reserveConfig, {
            accounts: toPublicKeys(Object.assign({ market,
                marketAuthority, owner: wallet.publicKey, oracleProduct: reserveAccounts.accounts.pythProduct, oraclePrice: reserveAccounts.accounts.pythPrice, quoteTokenMint, tokenProgram: spl_token_1.TOKEN_PROGRAM_ID, dexProgram: jet_engine_1.DEX_ID, clock: web3_js_1.SYSVAR_CLOCK_PUBKEY, rent: web3_js_1.SYSVAR_RENT_PUBKEY, systemProgram: web3_js_1.SystemProgram.programId }, reserveAccounts.accounts)),
            signers: [reserveAccounts.accounts.reserve, wallet.payer],
            instructions: [
                yield client.program.account.reserve.createInstruction(reserveAccounts.accounts.reserve),
            ],
        });
        return {
            program: jet_engine_1.JET_ID,
            reserve: reserve.publicKey,
            market: market,
            marketAuthority: marketAuthority,
            feeNoteVault: feeNoteVault,
            depositNoteMint: depositNoteMint,
            liquiditySupply: vault,
            pythPrice: pythPrice,
        };
    });
}
/**
 * Find a program derived address
 * @param programId The program the address is being derived for
 * @param seeds The seeds to find the address
 * @returns The address found and the bump seed required
 */
function findProgramAddress(programId, seeds) {
    return __awaiter(this, void 0, void 0, function* () {
        const seed_bytes = seeds.map((s) => {
            if (typeof s == "string") {
                return Buffer.from(s);
            }
            else if ("publicKey" in s) {
                return s.publicKey.toBytes();
            }
            else if ("toBytes" in s) {
                return s.toBytes();
            }
            else {
                return s;
            }
        });
        return yield web3_js_1.PublicKey.findProgramAddress(seed_bytes, programId);
    });
}
/**
 * Convert some object of fields with address-like values,
 * such that the values are converted to their `PublicKey` form.
 * @param obj The object to convert
 */
function toPublicKeys(obj) {
    const newObj = {};
    for (const key in obj) {
        const value = obj[key];
        if (typeof value == "string") {
            newObj[key] = new web3_js_1.PublicKey(value);
        }
        else if (typeof value == "object" && "publicKey" in value) {
            newObj[key] = value.publicKey;
        }
        else {
            newObj[key] = value;
        }
    }
    return newObj;
}
//# sourceMappingURL=jet.js.map